<template>
  <v-container fluid class="login-background">
    <v-layout row wrap style="align-content: baseline">
      <v-flex mt-5 mb-5 style="max-width:330px;margin:auto">
        <v-card class="login-card">
          <v-slide-y-transition group leave-absolute>
            <v-card-text v-if="user !== null"  style="height: 304px;" key="user-logged">
               <v-container>
                <v-layout row wrap>
                  <v-flex xs12 class="text-center">
                    <v-avatar size="100">
                      <v-img :src="avatar"></v-img>
                    </v-avatar>
                  </v-flex>
                  <v-flex xs12 class="headline grey--text mt-10  text-center">
                    {{ user.name }}
                  </v-flex>
                  <v-flex xs12 class="title grey--text text-center subtitle-1 text--lighten-1">
                    Bem vindo!
                  </v-flex>
                  <v-flex xs12 class="text-center mt-4">
                    <v-btn text color="primary" class="text-none" @click="logOut()">
                      Sair
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-text v-else key="user-not-set">
              <form @submit="login">
                <v-layout row wrap>
                  <v-flex xs12>
                    <h3 class="title mb-6">
                      Login
                    </h3>
                  </v-flex>
                  <v-flex xs12>
                    <div class="formInput">
                      <v-text-field outlined label="Usuário" v-model="email" placeholder="Digite seu e-mail aqui"></v-text-field>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <div class="formInput">
                      <v-text-field outlined label="Senha" v-model="password" type="password" placeholder="Digite sua senha aqui" @keyup.enter="login"></v-text-field>
                    </div>
                  </v-flex>
                  <v-flex xs7 mt-2 class="text-xs-center">
                    <v-btn type="submit" data-cy="login" rounded color="primary" depressed style="font-weight: 600;" :loading="loading">Login</v-btn>
                  </v-flex>

                  <v-flex xs5 mt-2 class="text-xs-center" v-if="false">
                    <v-dialog
                      v-model="dialog"
                      width="500"
                    >
                      <template v-slot:activator="{ on }">
                        <a v-on="on" class="primary--text link">Esqueci minha senha</a>
                      </template>
                      <v-card>
                        <v-card-text>
                          <v-flex xs12>
                            <h3 class="title mb-6">
                              Esqueci minha senha
                            </h3>
                          </v-flex>
                          <div class="formInput">
                            <v-text-field outlined label="Email" v-model="forgotPassworMail" placeholder="Digite seu e-mail aqui"  @keyup.enter="forgotPassword()"></v-text-field>
                          </div>
                          <v-flex xs12 mt-2 class="text-xs-center">
                            <v-btn rounded color="primary" class="text-none" depressed style="font-weight: 600;" @click="forgotPassword()" :loading="forgotPassworLoading">Enviar email</v-btn>
                          </v-flex>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                </v-layout>
              </form>
            </v-card-text>
          </v-slide-y-transition>
        </v-card>
      </v-flex>
    </v-layout>
  <v-layout v-if="user !== null">
      <v-spacer></v-spacer>
      <v-flex shrink>
        <v-btn @click="$router.push('/dashboard')">
          ir para o painel
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      loading: false,
      email: '',
      password: '',
      forgotPassworMail: '',
      dialog: false,
      forgotPassworLoading: false,
      error: null,
      newPassword: '',
      confirmNewPassword: '',
      loadingNewPassword: false
    }
  },
  methods: {
    ...mapActions('auth', ['authentication', 'logOut']),
    async login (e) {
      e.preventDefault()
      this.loading = true
      try {
        const result = await this.authentication({
          username: this.email.toLowerCase().trim(),
          password: this.password
        })
        this.error = !result
        if (result) {
          this.$router.push('/dashboard')
        }
      } catch (err) {
        this.$store.commit('snackbar/show', {
          text: 'Erro no cadastro',
          color: 'error'
        })
      }
      this.loading = false
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'avatar'])
  }
}
</script>

<style>
.v-label {
  background: white;
    padding-right: 4px;
}
.v-label.theme--dark {
   background: #424242
}
.login-background {
  padding-top: 57px;
  background: linear-gradient(to bottom, var(--v-tertiary-base) , var(--v-primary-base) 500px, #f7f8fc 500px)!important;
}
.logo-letter {
  color: #FFFFFF;
  font-size: 40px;
  font-style: italic;
  font-weight: 900;
  letter-spacing: -0.5px;
  line-height: 49px;
}
.login-call {
  height: 29px;
  width: 171px;
  color: #FFFFFF;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: 300;
  line-height: 29px;
}
.login-descripiton {
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 300;
}
.login-card {
  padding: 15px 44px 15px 44px;
  border-radius: 8px;
}
.social-divider {
  position: relative;
  z-index: 2;
  width: 200px;
  margin: auto;
  color: #C9CAD2;
  background :white;
}
.big-divider {
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background: #C9CAD2;
  margin-top: -10px;
  z-index: 0;
}
.svg-icons-wrapper svg{
  height: 32px;
  width: 32px;
  cursor: pointer;
}
.svg-icons-wrapper svg:hover{
  opacity: 0.9;
}
</style>
